import React, { useRef, useEffect, useCallback } from 'react';
import { func, oneOfType, number, string } from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getHeight = function getHeight(rows, el) {
  var _window$getComputedSt = window.getComputedStyle(el),
      borderBottomWidth = _window$getComputedSt.borderBottomWidth,
      borderTopWidth = _window$getComputedSt.borderTopWidth,
      lineHeight = _window$getComputedSt.lineHeight,
      paddingBottom = _window$getComputedSt.paddingBottom,
      paddingTop = _window$getComputedSt.paddingTop;

  var rowHeight = rows == null ? 0 : parseFloat(lineHeight) * parseInt(rows, 10) + parseFloat(borderBottomWidth) + parseFloat(borderTopWidth) + parseFloat(paddingBottom) + parseFloat(paddingTop);
  var scrollHeight = el.scrollHeight + parseFloat(borderBottomWidth) + parseFloat(borderTopWidth);
  return Math.max(rowHeight, scrollHeight);
}; // resize :: (Integer, Element) -> ()


var resize = function resize(rows, el) {
  if (el) {
    el.style.height = '0';
    el.style.height = "".concat(getHeight(rows, el), "px");
  }
}; // ExpandingTextarea :: Props -> <textarea />


var ExpandingTextarea = function ExpandingTextarea(props) {
  var ref = useRef(null);
  useEffect(function () {
    resize(props.rows, ref.current);
  }, [props.rows, props.value]);
  var handleInput = useCallback(function (e) {
    props.onChange(e);
    props.onInput(e);
    resize(props.rows, ref.current);
  }, [props]);
  return React.createElement("textarea", _extends({}, props, {
    onInput: handleInput,
    ref: ref
  }));
};

ExpandingTextarea.propTypes = {
  onChange: func,
  onInput: func,
  rows: oneOfType([number, string]),
  value: string
};
ExpandingTextarea.defaultProps = {
  onChange: Function.prototype,
  onInput: Function.prototype
};
export default ExpandingTextarea;
export { getHeight, resize };